import LinkRestrictedAccessIcon from '@atlaskit/icon-lab/core/link-restricted-access';
import * as React from 'react';

export function SvgLinkOff() {
  return <LinkRestrictedAccessIcon label="" testId="ads-refreshed-icon" />;
}
